import {
  BuyerProfile,
  CurrentUserBusinessRef,
  UpdateBuyerProfileRequest,
} from '../types';
import { delay } from './delay';
import { findActiveBusinessByUserId, findBuyerAccountByUserId } from './db';
import { ERR_NOT_FOUND } from './errors';
import { readUserIdFromToken } from './auth-utils';

const toBuyerProfile = (
  account: NonNullable<ReturnType<typeof findBuyerAccountByUserId>>,
): BuyerProfile => {
  let currentBusiness: CurrentUserBusinessRef | null = null;
  const found = findActiveBusinessByUserId(account.userId);
  if (found) {
    currentBusiness = {
      id: found.business.id,
      name: found.business.name,
      role: found.membership.role,
    };
  }
  return {
    id: account.userId,
    email: account.email,
    fullName: account.fullName,
    phone: account.phone,
    currentBusiness,
    defaultShippingAddress: account.defaultShippingAddress ?? null,
    defaultBillingAddress: account.defaultBillingAddress ?? null,
  };
};

export const profileMock = {
  me: async (): Promise<BuyerProfile> => {
    await delay(80, 200);
    const userId = readUserIdFromToken();
    const account = findBuyerAccountByUserId(userId);
    if (!account) throw ERR_NOT_FOUND('Buyer profile');
    return toBuyerProfile(account);
  },

  update: async (patch: UpdateBuyerProfileRequest): Promise<BuyerProfile> => {
    await delay();
    const userId = readUserIdFromToken();
    const account = findBuyerAccountByUserId(userId);
    if (!account) throw ERR_NOT_FOUND('Buyer profile');
    if (patch.fullName !== undefined) account.fullName = patch.fullName;
    if (patch.phone !== undefined) account.phone = patch.phone;
    if (patch.defaultShippingAddress !== undefined)
      account.defaultShippingAddress = patch.defaultShippingAddress ?? undefined;
    if (patch.defaultBillingAddress !== undefined)
      account.defaultBillingAddress = patch.defaultBillingAddress ?? undefined;
    return toBuyerProfile(account);
  },
};
